'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n        bottom: 5px;\n        left: 50%;\n        transform: translateX(-7px);\n        border-width: 7px 7px 0 7px;\n        border-color: ', ' transparent transparent transparent;\n      '], ['\n        bottom: 5px;\n        left: 50%;\n        transform: translateX(-7px);\n        border-width: 7px 7px 0 7px;\n        border-color: ', ' transparent transparent transparent;\n      ']),
    _templateObject2 = _taggedTemplateLiteral(['\n        top: 50%;\n        left: 5px;\n        transform: translateY(-7px);\n        border-width: 7px 7px 7px 0;\n        border-color: transparent ', ' transparent transparent;\n      '], ['\n        top: 50%;\n        left: 5px;\n        transform: translateY(-7px);\n        border-width: 7px 7px 7px 0;\n        border-color: transparent ', ' transparent transparent;\n      ']),
    _templateObject3 = _taggedTemplateLiteral(['\n        top: 5px;\n        left: 50%;\n        transform: translateX(-7px);\n        border-width: 0 7px 7px 7px;\n        border-color: transparent transparent ', ' transparent;\n      '], ['\n        top: 5px;\n        left: 50%;\n        transform: translateX(-7px);\n        border-width: 0 7px 7px 7px;\n        border-color: transparent transparent ', ' transparent;\n      ']),
    _templateObject4 = _taggedTemplateLiteral(['\n        top: 50%;\n        right: 5px;\n        transform: translateY(-7px);\n        border-width: 7px 0 7px 7px;\n        border-color: transparent transparent transparent ', ';\n      '], ['\n        top: 50%;\n        right: 5px;\n        transform: translateY(-7px);\n        border-width: 7px 0 7px 7px;\n        border-color: transparent transparent transparent ', ';\n      ']),
    _templateObject5 = _taggedTemplateLiteral([''], ['']),
    _templateObject6 = _taggedTemplateLiteral(['\n        padding-bottom: 12px;\n        bottom: 100%;\n        left: 50%;\n        transform: translateX(-50%);\n      '], ['\n        padding-bottom: 12px;\n        bottom: 100%;\n        left: 50%;\n        transform: translateX(-50%);\n      ']),
    _templateObject7 = _taggedTemplateLiteral(['\n        padding-left: 12px;\n        top: 50%;\n        left: 100%;\n        transform: translateY(-50%);\n      '], ['\n        padding-left: 12px;\n        top: 50%;\n        left: 100%;\n        transform: translateY(-50%);\n      ']),
    _templateObject8 = _taggedTemplateLiteral(['\n        padding-top: 12px;\n        top: 100%;\n        left: 50%;\n        transform: translateX(-50%);\n      '], ['\n        padding-top: 12px;\n        top: 100%;\n        left: 50%;\n        transform: translateX(-50%);\n      ']),
    _templateObject9 = _taggedTemplateLiteral(['\n        padding-right: 12px;\n        top: 50%;\n        right: 100%;\n        transform: translateY(-50%);\n      '], ['\n        padding-right: 12px;\n        top: 50%;\n        right: 100%;\n        transform: translateY(-50%);\n      ']),
    _templateObject10 = _taggedTemplateLiteral(['\n  position: absolute;\n  z-index: 10;\n  pointer-events: ', ';\n  visibility: ', ';\n  opacity: ', ';\n  ', ';\n  ', ';\n'], ['\n  position: absolute;\n  z-index: 10;\n  pointer-events: ', ';\n  visibility: ', ';\n  opacity: ', ';\n  ', ';\n  ', ';\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  max-width: 300px;\n  padding: 10px;\n  text-align: center;\n  background: ', ';\n  border-radius: 3px;\n  color: ', ';\n  font-size: 12px;\n  background: ', ';\n'], ['\n  max-width: 300px;\n  padding: 10px;\n  text-align: center;\n  background: ', ';\n  border-radius: 3px;\n  color: ', ';\n  font-size: 12px;\n  background: ', ';\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  ', ';\n'], ['\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Styles


var arrowPosition = function arrowPosition(_ref) {
  var position = _ref.position;

  switch (position) {
    case 'top':
      return (0, _styledComponents.css)(_templateObject, _colors.black);

    case 'right':
      return (0, _styledComponents.css)(_templateObject2, _colors.black);

    case 'bottom':
      return (0, _styledComponents.css)(_templateObject3, _colors.black);

    case 'left':
      return (0, _styledComponents.css)(_templateObject4, _colors.black);

    default:
      return (0, _styledComponents.css)(_templateObject5);
  }
};

var containerPosition = function containerPosition(_ref2) {
  var position = _ref2.position;

  switch (position) {
    case 'top':
      return (0, _styledComponents.css)(_templateObject6);

    case 'right':
      return (0, _styledComponents.css)(_templateObject7);

    case 'bottom':
      return (0, _styledComponents.css)(_templateObject8);

    case 'left':
      return (0, _styledComponents.css)(_templateObject9);

    default:
      return (0, _styledComponents.css)(_templateObject5);
  }
};

var Container = _styledComponents2.default.div(_templateObject10, function (_ref3) {
  var visible = _ref3.visible;
  return visible ? 'auto' : 'none';
}, function (_ref4) {
  var visible = _ref4.visible;
  return visible ? 'visible' : 'hidden';
}, function (_ref5) {
  var visible = _ref5.visible;
  return visible ? 1 : 0;
}, (0, _polished.transitions)('visibility .3s ease-in-out, opacity .3s ease-in-out, transform .3s ease-in-out'), containerPosition);

var Content = _styledComponents2.default.div(_templateObject11, _colors.white, _colors.white, _colors.black);

var Arrow = _styledComponents2.default.div(_templateObject12, arrowPosition);

var TooltipDropDown = function TooltipDropDown(_ref6) {
  var children = _ref6.children,
      visible = _ref6.visible,
      position = _ref6.position;
  return _react2.default.createElement(Container, {
    visible: visible,
    position: position
  }, _react2.default.createElement(Arrow, {
    position: position
  }), _react2.default.createElement(Content, null, children));
};

TooltipDropDown.propTypes = {
  children: _propTypes2.default.node,
  visible: _propTypes2.default.bool,
  position: _propTypes2.default.string
};
exports.default = TooltipDropDown;